import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ITemplateValidationRule } from 'sections/design/template-management/entities/templates';
import { getValidationItemDescription } from 'sections/design/template-management/sections/template-editor/utils/validation-helpers';

const Wrapper = styled.div<StyledProps>`
  height: 'auto';
  display: 'flex';
`;

interface StyledProps {
  containerOpen?: boolean;
}

interface IProps {
  validationItem: ITemplateValidationRule;
}

type Props = IProps & StyledProps;

export const ValidationItemBody = ({ validationItem }: Props) => {
  const { t } = useTranslation('trackingLinks');
  return <Wrapper>{getValidationItemDescription(validationItem.rule, t)}</Wrapper>;
};
